import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=2d42121d&scoped=true&"
import script from "./Profile.vue?vue&type=script&lang=js&"
export * from "./Profile.vue?vue&type=script&lang=js&"
import style0 from "./Profile.vue?vue&type=style&index=0&id=2d42121d&prod&lang=scss&"
import style1 from "./Profile.vue?vue&type=style&index=1&id=2d42121d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d42121d",
  null
  
)

export default component.exports